/**
 * Shop All Side Menu
 */
(() => {
  /**
   * Logo
   */
  document.querySelector('.verticalmenu nav').prepend(
    document.querySelector('footer.footer .logo').cloneNode(true),
  );

  document.querySelector('.header-mobile .dropdown-extras').prepend(
    document.querySelector('footer.footer .logo').cloneNode(true),
  );

  /**
   * clone search
   */
  (() => {
    const search = document.querySelector('.header-full .search_container');
    if (search) {
      document.querySelector('.verticalmenu nav.cd-dropdown').appendChild(search.cloneNode(true));
    }
  })();

  /**
   * Tier 1
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children > a').forEach((item) => {
    item.setAttribute('href', 'javascript:;');

    item.innerHTML = `
      <p>${item.innerHTML}</p>
    `;

    // Handle On-click
    item.addEventListener('click', (e) => {
      document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children').forEach((itemmenu) => {
        if (itemmenu === e.currentTarget.parentNode) return;
        itemmenu.classList.remove('active');
      });
      e.currentTarget.parentNode.classList.toggle('active');
      e.currentTarget.parentNode.querySelector('.cd-secondary-dropdown').classList.toggle('is-hidden');
    });
  });

  // Close button Tier 1
  let close = document.createElement('div');
  close.innerHTML = '<a class="close-button">x</a>';
  close = close.firstElementChild;
  close.setAttribute('href', '#');
  close.addEventListener('click', () => {
    document.querySelector('body').click();

    document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children').forEach((itemmenu) => {
      itemmenu.classList.remove('active');
    });
  });
  document.querySelector('.cd-dropdown').prepend(close);

  /**
   * Tier 2 Sidebar
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children .cd-secondary-dropdown').forEach((sidemenu) => {
    sidemenu.querySelector('.go-back').remove(); // remove back button
    const menuHeader = sidemenu.parentNode.querySelector('a').cloneNode(true);

    sidemenu.innerHTML = /* html */ `
        <div class="nLeft">
          <div class="nTop nFlex">
            ${menuHeader.outerHTML}
          </div>
          <div class="nBottom">
            ${sidemenu.innerHTML}
          </div>
        </div>
      `;

    // Close button Tier 2
    let closeTier2 = document.createElement('div');
    closeTier2.innerHTML = '<a class="close-button">x</a>';
    closeTier2 = closeTier2.firstElementChild;
    closeTier2.setAttribute('href', '#');
    closeTier2.addEventListener('click', () => {
      sidemenu.parentNode.classList.remove('active');
    });
    sidemenu.querySelector('.nLeft').prepend(closeTier2);
  });

  // ** View All
  const tierThreeTitle = document.querySelectorAll('.cd-secondary-dropdown .nBottom > li.view-all:not(.menu-header)');
  tierThreeTitle.forEach((title) => {
    const titleLink = title.querySelector('a');
    const titleLinkClone = titleLink.cloneNode(false);
    titleLinkClone.textContent = 'View All';
    titleLinkClone.classList.add('view-all-link');
    const miniMenu = title.querySelector('.is-hidden');
    miniMenu.appendChild(titleLinkClone);

    // ** Limit Tier 3 to 6 items
    const listItems = title.getElementsByTagName('li');
    if (listItems.length > 6) {
      for (let i = 6; i < listItems.length; i += 1) {
        listItems[i].style.display = 'none';
      }
    }
  });
})();
